<template>
  <div class="default-layout">
    <TopBar class="default-layout__top-bar" />
    <aside class="default-layout__side-bar">
      <component :is="shouldUseNewSideBar ? SideBarNew : SideBar" />
    </aside>
    <main
      :class="{
        'default-layout__main': true,
        'default-layout__main--minimized': isSideBarMinimized,
      }"
    >
      <RouterView data-cy="default-layout__main-content" />
      <BlogLinkContainer />
    </main>
  </div>
</template>

<script setup lang="ts">
import BlogLinkContainer from "search/BlogLinkContainer.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import SideBar from "@host/components/SideBar.vue";
import TopBar from "@host/components/TopBar.vue";
import SideBarNew from "@host/components/side-bar/SideBarNew.vue";
import { sideBarStore } from "@host/store/side-bar";

const route = useRoute();

const { isSideBarMinimized } = sideBarStore();

const shouldUseNewSideBar = computed(() => route.meta.useNewSideBar === true);
</script>

<style lang="scss">
.default-layout {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  width: 100%;
  max-width: 100vw;
}

.default-layout__top-bar {
  grid-column: 1 / 3;
  z-index: map.get($z-indexes, "top-bar");
}

.default-layout__side-bar {
  grid-column: 1;
  grid-row: 2;
}

.default-layout__main {
  grid-column: 2;
  grid-row: 2;
}
</style>
